import React, { useEffect, useState } from 'react';
import config from '../../constants/config';
import Spinner from '../../components/UI/Spinner/Spinner';

const ApiProxyRedirectorContainer = ({ location }) => {

  /**
   * This component is used to fetch API URLs and redirect the user to the appropriate URL after getting the response from server
   * This is because service worker is not able to handle URL directly because Router is fired first
   */
  useEffect(async () => {
    const fullApiUrl = location.pathname + location.search + '&bots_filtered=1';

    await fetch(fullApiUrl, {
      method: 'GET',
      mode: 'cors',
    })
      .then((res) => {
        window.location.href = res.url;
      })
      .catch((err) => {
        window.location.href = '/';
      });
  }, [location]);

  return (
    <div style={{ width: '100%', height: '100%', minWidth: '100%', minHeight: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed' }}>
      <Spinner size='large' />
    </div>
  );
};

export default ApiProxyRedirectorContainer;
